import ApiBase from '@/api/ApiBase';

export default class Authorization extends ApiBase {
  authorizeOnIp(data = {}, options = {}) {
    return this.request('POST', 'authorize/ip', { data, ...options });
  }

  login(data = {}, options = {}) {
    return this.request('POST', 'authorize/login', { data, ...options });
  }
}
